module.exports = __webpack_public_path__ + "static/sdfljdsf_2x-e2fb9555470e3c39825990459fbb483b.png";